/**!
 * Created by Leonardo Cheslacki on 18/12/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

let _this = {};

class HelpersCore {
    /**
     *
     */
    constructor() {
        this.$base_uri = ((typeof (location) !== 'undefined') ? `${location.protocol}//${location.host}` : 'http://localhost');
        _this = this;
    };

    /**
     *
     * @protected
     */
    _void = () => {
    };

    /**
     *
     * @param array
     * @returns {boolean}
     */
    isArray = (array) => {
        return Boolean(Array.isArray(array));
    };

    /**
     *
     * @param array
     * @returns {boolean}
     */
    isArrayIf = (array) => {
        return Boolean(this.isArray(array) && array.length);
    };

    /**
     *
     * @param array
     * @param value
     * @returns {boolean}
     */
    inArray = (array, value) => {
        return Boolean(this.isArrayIf(array) && (array.indexOf(value) > -1));
    };

    /**
     *
     * @param array
     * @param value
     */
    removeArray = (array, value) => {
        this.inArray(array, value) && array.splice(array.indexOf(value), 1);
    };

    /**
     *
     * @param array
     * @param value
     * @param key
     * @returns {*}
     */
    getArray = (array, value, key = null) => {
        return this.inArray(array, value) && array[array.indexOf(value)] || (array.find((object) => (!!key && (object[key] === value))));
    };

    /**
     *
     * @param array
     * @returns {*}
     */
    firstArray = (array) => {
        if (this.isArrayIf(array)) {
            return array[0];
        }
    };

    /**
     *
     * @param array
     * @returns {*}
     */
    lastArray = (array) => {
        if (this.isArrayIf(array)) {
            return array[array.length - 1];
        }
    };

    /**
     *
     * @param array
     * @returns {*}
     */
    randomArray = (array) => {
        return array[Math.floor(Math.random() * array.length)];
    }

    /**
     *
     * @param array
     * @returns {*}
     */
    randomArrayNoRepeat = (array) => {
        if (this.isArrayIf(array)) {
            let
                random = Math.floor(Math.random() * array.length),
                value = array[random];

            array.splice(random, 1);

            return value;
        }
    };

    /**
     *
     * @param value
     * @returns {boolean}
     */
    isEmpty = (value) => {
        return Boolean((value === null) || (typeof (value) === 'undefined') || ((typeof (value) === 'string') && !value.trim()));
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isObject = (object) => {
        return Boolean((!this.isEmpty(object) && !this.isArray(object)) && (typeof (object) === 'object'));
    };

    /**
     *
     * @param object
     * @returns {false|number}
     */
    lengthObject = (object) => {
        return this.isObject(object) && (((typeof (object.length) !== 'undefined') && object.length) || Object.keys(object).length);
    };

    /**
     * array-like
     * @param object
     * @returns {boolean}
     */
    isObjectIf = (object) => {
        return Boolean(this.lengthObject(object));
    };

    /**
     *
     * @param object
     * @param field
     * @returns {boolean}
     */
    inObject = (object, field) => {
        return Boolean(this.isObjectIf(object) && typeof (object[field]) !== 'undefined');
    };

    /**
     *
     * @param object
     * @returns {false|string[]}
     */
    keysObject = (object) => {
        return this.isObjectIf(object) && Object.keys(object);
    };

    /**
     *
     * @param object
     * @returns {false|string[]}
     */
    keyObject = (object) => {
        return this.keysObject(object) && this.firstArray(Object.keys(object));
    };

    /**
     *
     * @param object
     * @returns {false|string[]}
     */
    valuesObject = (object) => {
        return this.keysObject(object) && Object.values(object);
    };

    /**
     *
     * @param object
     * @returns {false|string[]}
     */
    valueObject = (object) => {
        return this.keysObject(object) && this.firstArray(Object.values(object));
    };

    /**
     *
     * @param object
     * @param field
     * @returns {false|string|*}
     */
    getObject = (object, field) => {
        return this.inObject(object, field) && this.verifyField(object, field, false, null);
    };

    /**
     *
     * @param object
     * @param field
     */
    removeObject = (object, field) => {
        this.inObject(object, field) && delete object[field];
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isFunction = (object) => {
        return Boolean(!this.isEmpty(object) && (typeof (object) === 'function'));
    };

    /**
     *
     * @param object
     * @param method
     * @returns {boolean}
     */
    inFunction = (object, method) => {
        return Boolean(this.isObject(object) && (typeof (object[method]) === 'function'));
    };

    /**
     *
     * @param array
     * @param index
     * @param length
     * @param done
     * @param always
     */
    recursiveSyncMap = (array, index, length, done, always) => {
        done(array[index], () => {
            if (length > ++index) {
                this.recursiveSyncMap(array, index, length, (item, next, stop, index) => {
                    done(item, next, stop, index);
                }, () => {
                    (typeof (always) === 'function') && always(true);
                })
            } else {
                (typeof (always) === 'function') && always(true);
            }
        }, () => {
            (typeof (always) === 'function') && always(true);
        }, index);
    };

    /**
     *
     * @param length
     * @param i
     * @returns {boolean}
     */
    endFor = (length, i) => {
        return Boolean(length === (i + 1));
    };

    /**
     *
     * @param data {object}
     * @param field {string}
     * @param prefix {string | boolean}
     * @param empty {*}
     * @returns {string|*}
     */
    verifyField = (data, field, prefix = false, empty = false) => {
        let array = field.split('.');
        if (this.isArrayIf(array)) {
            let length = array.length, temp = data;
            for (let i = 0; length > i; i++) {
                if (this.isObjectIf(temp) && temp.hasOwnProperty(array[i])) {
                    temp = !this.isEmpty(temp[array[i]]) ? temp[array[i]] : empty;
                } else {
                    temp = empty;
                }
                if (this.endFor(length, i)) {
                    return ((prefix && !!temp) ? `${prefix}${temp}` : temp);
                }
            }
        }
    };

    /**
     * % A literal percent character. No argument is required.
     * s The argument is treated and presented as a string.
     * u The argument is treated as an integer and presented as an unsigned decimal number.
     * @param string
     * @returns {*}
     */
    printF = function (string) {
        let args = Array.prototype.slice.call(arguments);

        if (_this.isArrayIf(args)) {
            _this.recursiveSyncMap(args, 1, args.length, (item, next, stop) => {
                switch (typeof (item)) {
                    case 'string':
                        string = string.toString().replace('%s', item);
                        next(true);
                        break;
                    case 'number':
                        string = string.toString().replace('%u', item);
                        next(true);
                        break;
                    default:
                        stop(true);
                }
            });
        }

        return string;
    };

    /**
     *
     * @param start
     * @param end
     * @param step
     * @returns {unknown[]}
     */
    createArray = (start, end, step) => {
        return Array.from({length: (end - start) / step + 1}, (value, index) => start + index * step);
    };

    /**
     *
     * @param callback
     * @returns {boolean}
     */
    isTablet = (callback = null) => {
        const agent = navigator.userAgent || navigator.vendor || window.opera;

        if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(agent)) {
            (typeof (callback) === 'function') && callback(true);
            return true;
        } else {
            (typeof (callback) === 'function') && callback(false);
            return false;
        }
    };

    /**
     *
     * @param callback
     * @returns {boolean}
     */
    isMobile = (callback = null) => {
        const agent = navigator.userAgent || navigator.vendor || window.opera;

        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(agent.substring(0, 4))) {
            (typeof (callback) === 'function') && callback(true);
            return true;
        } else {
            (typeof (callback) === 'function') && callback(false);
            return false;
        }
    };
}

module.exports = HelpersCore;
